import { useDependencies } from '@servicetitan/react-ioc';
import { useCallback } from 'react';
import { LegalAgreementStore } from '../stores/legal-agreement.store';

export const useDownloadCurrentTerms = () => {
    const [legalStore] = useDependencies(LegalAgreementStore);

    return useCallback(async () => {
        let agreement = legalStore.agreement;
        if (!agreement) {
            await legalStore.fetch();
            agreement = legalStore.agreement;
        }
        if (!agreement) {
            return;
        }

        const { downloadAgreementPdf } = await import('./download-agreement-pdf');
        await downloadAgreementPdf(agreement.body, `terms-of-service-v${agreement.version}.pdf`);
    }, [legalStore]);
};
